import type { EditorState, Transaction } from '@tiptap/pm/state'
import { TextSelection } from '@tiptap/pm/state'
import { EditorView } from '@tiptap/pm/view'

export function contentElementFiltered(dom: HTMLElement, qualifiedName = '') {
  const children = Array.from(dom.children)
  return (children.find(child => !child.hasAttribute(qualifiedName)) as HTMLElement) || dom
}

export function getLoopVarParts(text: string) {
  const arrayVariable = 'item'
  let arrayName = '[]'
  let arrayField = ''

  if (text.includes('.*.')) {
    const arr = text.split('.*.')
    arrayName = arr[0] || '[]'
    arrayField = arr[1]
  }

  return { arrayName, arrayVariable, arrayField }
}

export function findAncestorDepthByNames(state: EditorState, names: string[] = ['ifBlock', 'forBlock']) {
  const { $from } = state.selection
  for (let d = $from.depth; d >= 0; d--) {
    if (names.includes($from.node(d).type.name)) {
      return d
    }
  }
  return -1
}

export function isAtEndOfNode(state: EditorState, depth: number) {
  const { selection } = state
  if (!selection.empty) return false
  const $pos = selection.$from
  // Caret is considered “at end” if it’s at or beyond the last caretable spot
  // inside the node. The absolute end position is one step AFTER that.
  return $pos.depth < depth ? false : $pos.pos >= $pos.end(depth) - 1
}

export function isLastInItsParent(state: EditorState, nodePos: number) {
  // nodePos must be the START position of the block node
  const $pos = state.doc.resolve(nodePos)

  // Parent of the block at nodePos
  const parent = $pos.parent
  if (!parent) return false

  // Index of the block among siblings at this depth
  const indexInParent = $pos.index() // same as $pos.index($pos.depth)

  return indexInParent === parent.childCount - 1
}

export function insertParagraphAfterNode(state: EditorState, tr: Transaction, nodePos: number) {
  const node = state.doc.nodeAt(nodePos)
  if (!node) return tr
  const posAfter = nodePos + node.nodeSize
  const para = state.schema.nodes.paragraph.create()
  tr.insert(posAfter, para)
  // place caret inside the new paragraph
  const $end = tr.doc.resolve(posAfter + 1)
  tr.setSelection(new TextSelection($end))
  return tr
}

export function handleKeyDownForBlocks(view: EditorView, event: KeyboardEvent) {
  // Only care about ArrowDown or Shift+Enter
  const isArrowDown = event.key === 'ArrowDown' && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey
  const isShiftEnter = event.key === 'Enter' && event.shiftKey
  if (!isArrowDown && !isShiftEnter) return false

  const { state } = view
  const depth = findAncestorDepthByNames(state)
  if (depth < 0) return false

  // We only act if the caret is at the end of the block's content
  if (!isAtEndOfNode(state, depth)) return false

  // start position of the block at that depth
  const nodePos = state.selection.$from.before(depth)
  // only create a new paragraph when the block is the last in its parent
  if (!isLastInItsParent(state, nodePos)) return false

  event.preventDefault()
  const tr = insertParagraphAfterNode(state, state.tr, nodePos)
  view.dispatch(tr)
  return true
}
